import axios from 'axios';
import { SummaryData, VideoData, VideoApiResponse } from '../types/socialGlass';
import { decryptfromHEX } from '../../routes/encodedecode';

export const fetchSummaryData = async (): Promise<SummaryData> => {
  // Get orgID from URL if needed, or use "1" as default
  const queryParams = new URLSearchParams(window.location.search);
  const encrypted = queryParams.get("p");
  let orgID = "";
  
  if (encrypted) {
    try {
      const decrypted = decryptfromHEX(encrypted);
      const parsed = JSON.parse(decrypted);
      orgID = parsed.orgID;
      console.log("Decrypted orgID:", orgID);
    } catch (err) {
      console.error("Failed to decrypt orgID from URL:", err);
    }
  }

  const response = await axios.get(
    `https://genz-staging.feeltiptop.com/api/user/get_report`,
    {
      params: {
        p: orgID,
        section: "Summary",
      },
    },
  );
  
  return response.data;
};

export const fetchVideoData = async (postIds: string[]): Promise<Record<string, VideoData>> => {
  if (postIds.length === 0) return {};

  const queryString = postIds
    .filter((postId) => postId && postId !== "")
    .map((postId) => `postIDs=${postId}`)
    .join("&");

  try {
    const videoResponse = await axios.get<VideoApiResponse>(
      `https://genz-staging.feeltiptop.com/api/social_glass/getPostsDataArr?${queryString}`,
      {},
    );

    console.log("Raw response:", videoResponse);
    console.log("Response data:", videoResponse.data);
    console.log("Response status:", videoResponse.status);
    
    if (videoResponse.data && Array.isArray(videoResponse.data.data)) {
      const videoData = videoResponse.data.data.reduce(
        (acc, element) => {
          acc[element.post_id] = element;
          return acc;
        },
        {} as Record<string, VideoData>,
      );

      console.log("Video data: ", videoData);
      return videoData;
    } else {
      console.error("Invalid video data format:", videoResponse.data);
      return {};
    }
  } catch (videoErr) {
    console.error("Full error object:", videoErr);
    console.error("Error response:", videoErr.response?.data);
    console.error("Error status:", videoErr.response?.status);
    return {};
  }
};
